import React from 'react';
import { Button } from 'react-bootstrap';

import './ButtonRedirect.css';

export default function ButtonRedirect(props) {
  return (
    <Button
      type="button"
      onClick={props.onClick}
      style={{ border: 'none', ...props.style }}
      className="yellow d-block w-100 rounded-1 text-nowrap"
      disabled={props.disabled}>
      {props.title}
    </Button>
  );
}
